import { useState } from "react";
import { NorthEast } from "@mui/icons-material";
import { Grid2, CircularProgress } from "@mui/material";

import {
  StyledCardWrapper,
  StyledTitle,
  StyledIconBox,
  iconSx,
  spinnerSx,
} from "./NirvaContentCard.styles";
import {
  safeFileName,
  isS3Link,
  downloadViaFetch,
  downloadViaIframe,
  navigateTo,
} from "./NirvaContentCard.utils";

const NirvaContentCard = ({ title, setModalState, bigB, link, openModal }) => {
  const [downloading, setDownloading] = useState(false);

  const handleClick = async () => {
    if (openModal) {
      setModalState(true);
      return;
    }
    if (!link) return;

    if (!isS3Link(link)) {
      window.open(link, "_blank", "noopener,noreferrer");
      return;
    }

    setDownloading(true);
    const filename = safeFileName(title);

    try {
      await downloadViaFetch(link, filename);
      setDownloading(false);
      return;
    } catch (err) {
      console.warn("Fetch download failed:", err);
    }

    try {
      downloadViaIframe(link);
      setTimeout(() => setDownloading(false), 2000);
      return;
    } catch (err) {
      console.warn("Iframe download failed:", err);
    }

    try {
      navigateTo(link);
    } catch (err) {
      console.error("Navigation fallback failed:", err);
      window.open(link, "_blank", "noopener,noreferrer");
    } finally {
      setTimeout(() => setDownloading(false), 2000);
    }
  };

  const clickable = openModal || !!link;

  return (
    <Grid2 item size={{ lg: 4, md: 6, sm: 6, xs: 12 }}>
      <StyledCardWrapper
        onClick={handleClick}
        clickable={clickable}
        bigB={bigB}
      >
        <StyledTitle>{title}</StyledTitle>

        {link && (
          <StyledIconBox>
            {downloading ? (
              <CircularProgress size={20} sx={spinnerSx} />
            ) : (
              <NorthEast sx={iconSx} />
            )}
          </StyledIconBox>
        )}
      </StyledCardWrapper>
    </Grid2>
  );
};

export default NirvaContentCard;
